/** @jsxImportSource @emotion/react */
export default function Botonera({ children }) {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "row",
        gap: "1em",
      }}
    >
      {children}
    </div>
  );
}
